import React, { Component } from 'react';
import { mapDbCashFlow } from 'utils/mappers';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import { connect } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import { getCashDrawer } from 'actions/DashboardActions';

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const date = new Date();

class CashFlow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const cashdrawer = this.props.cashdrawer;

        return (
            <div id="chart5" className="item col-4-p-0">
                <DashDialog 
                    text="Today's Cash Flow"
                    link="/report/daily-cash-summary"
                    classicClass="bg-ClassicGreen"
                    isReport={true}
                    refreshAction={() => this.props.getCashDrawer(this.props.branchId)} />
                {
                    this.props.loading
                        ?
                        <LinearProgress variant="indeterminate" />
                        :
                        <div className="cashflow_height">
                            <GenericTable
                                className="table_center tableHeaderCashFlow"
                                multiSelectable={false}
                                enableSelectAll={false}
                                selectable={false}
                                stripedRows={true}
                                columns={LOOKUP.cashFlowInfo.dashBoardTable}
                                rows={mapDbCashFlow(cashdrawer)}
                            />
                        </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.common.dbCashFlowCall > 0,
        branchId: state.common.branchId,
    }
}
function mapDispatchToProps(dispatch){
    return {
        getCashDrawer: (branchId) => dispatch(getCashDrawer(branchId, true)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashFlow);